import { SlackChannels } from '../../pure-js/enums/SlackChannels.js'
import { slack } from './SlackHelper.js'
import { googleChat } from './GoogleChatHelper.js'

/**
 * Sends notifications to Slack. Google Chat is deprecated and disabled
 * (enableGoogleChat: false); the googleChat call is retained for future re-enablement.
 * Uses Promise.allSettled so each path is independent — if one fails, the other still sends.
 */
export const notify = async (text: string, channel: SlackChannels): Promise<void> => {
  await Promise.allSettled([slack(text, channel), googleChat(text, channel)])
}
